import { getLoveveryAnonymousUser } from './api/accountManager';
import { isServerSide } from '@/utils/environment';

export async function getLoveveryId(): Promise<string | null> {
  if (isServerSide()) {
    return null;
  } else {
    const loveveryId = _getLoveveryIdFromLocalStorage();

    return loveveryId ? loveveryId : await _generateNewLoveveryId();
  }
}

async function _generateNewLoveveryId() {
  try {
    // Fetch the anonymous user from the account manager API
    // Multuple calls to this function will return the same promise
    // until the first one resolves
    const loveveryAnonymousUser = await getLoveveryAnonymousUser();
    const loveveryId = loveveryAnonymousUser?.data?.uuid;

    if (loveveryId) {
      setLoveveryIdInLocalStorage(loveveryId);
      return loveveryId;
    }
  } catch (e) {
    if (e instanceof Error) return e.message;
    const errorString = String(e);
    console.error(
      `[manageLoveveryID]: Unable to generate loveveryId: ${errorString}`,
    );
  }

  return null;
}

const LOVEVERY_ID_KEY = 'lovevery_id';

function _getLoveveryIdFromLocalStorage() {
  return localStorage.getItem(LOVEVERY_ID_KEY);
}

export function setLoveveryIdInLocalStorage(loveveryId: string) {
  localStorage.setItem(LOVEVERY_ID_KEY, loveveryId);

  return null;
}
